'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DraggableList = require('./DraggableList');

var _DraggableList2 = _interopRequireDefault(_DraggableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _DraggableList2["default"]; // export this package's api

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-drag-list/lib/index.js
// module id = 156
// module chunks = 0